module.exports = __webpack_public_path__ + "img/logo-sidebar.e263636b.svg";